<template>
  <swiper-slide class="swiper3">
    <head-bar :main_title="main_title"></head-bar>
    <div class="contanier">
      <div class="left">
        <div class="item" :class="activeNum == 1 ? 'active' : ''">
          <div>
            <p>基础标签</p>
            <span
              >对应到人员基础字段的标签，比如年龄、性别、婚姻、学历、职业、单位、交通、城市、收入、星座、生肖、用电、用水……</span
            >
          </div>
          <img src="../assets/icon1.png" />
        </div>
        <div class="item" :class="activeNum == 2 ? 'active' : ''">
          <div>
            <p>行为标签</p>
            <span
              >对应到人员行为的标签，比如出行、购物、贷款、还款、逾期、理财、上网、运动、投资、社交、买房、买车、理财、逛街、娱乐、代购、带货、直播……</span
            >
          </div>
          <img src="../assets/icon2.png" />
        </div>
        <div class="item" :class="activeNum == 3 ? 'active' : ''">
          <div>
            <p>轨迹标签</p>
            <span
              >对应人员轨迹的标签，比如应用安装、上网浏览、兴趣爱好、打车记录、购物小票、航班信息、健身记录、旅行足迹……</span
            >
          </div>
          <img src="../assets/icon3.png" />
        </div>
        <div class="bottom">
          <div class="b_item" v-for="(item, index) in dataListL" :key="index">
            <div class="itemBox">
              <div class="cir" :class="item.value == 1 ? 'cir1' : 'cir2'"></div>
              <span>{{ item.num }}</span>
            </div>
            <div class="cirb">{{ item.name }}</div>
            <span class="subtit">{{item.subtitle}}</span>
          </div>
          <!-- <div class="b_item">
            <div class="itemBox">
              <div class="cir cir1"></div>
              <span>3000+</span>
            </div>
            <div class="cirb">已建设</div>
          </div>
          <div class="b_item">
            <div class="itemBox">
              <div class="cir cir2"></div>
              <span>18+</span>
            </div>
            <div class="cirb">大类标签</div>
          </div> -->
        </div>
      </div>
      <div class="center">
        <div class="label_chart">
          <img src="../assets/human.png" />
          <div id="all">
            <!--主屏显示-->
            <div id="main">
              <!--所有li模块-->
              <div id="list">
                <ul></ul>
              </div>
              <!--左下角按钮-->
              <div id="btn" style="display: none">
                <ul>
                  <li>Table</li>
                  <li>Sphere</li>
                  <li>Helix</li>
                  <li>Grid</li>
                </ul>
              </div>
              <!--返回按钮-->
            </div>
          </div>
        </div>
        <div class="tag_total">
          <p>标签总量</p>
          <span>30000+</span>
        </div>
      </div>
      <div class="left right">
        <div class="item" :class="activeNum == 4 ? 'active' : ''">
          <img src="../assets/icon4.png" />
          <div>
            <p>关系标签</p>
            <span
              >对应人员关系的标签，比如家人、父母、父子、母子、父女、母女、朋友、同学、发小、老乡、校友、同事、同行、下属、领导、社群、社团、社区……</span
            >
          </div>
        </div>
        <div class="item" :class="activeNum == 5 ? 'active' : ''">
          <img src="../assets/icon5.png" />
          <div>
            <p>营销标签</p>
            <span
              >从对应业务种类中提取，如忠诚度、满意度、流失率、活跃度、受理度、黑名单、成本、钱包、紧密度、欺诈、违约、信用分、征信等级……</span
            >
          </div>
        </div>
        <div class="item" :class="activeNum == 6 ? 'active' : ''">
          <img src="../assets/icon6.png" />
          <div>
            <p>业务标签</p>
            <span
              >以合格用户与意愿来搭建，如电商、团购、零售、出口、进口、直销、分销、代理、推广、运营、物流运输……</span
            >
          </div>
        </div>
        <div class="bottom">
          <div class="b_item" v-for="(item, index) in dataListR" :key="index">
            <div class="itemBox">
              <div class="cir" :class="item.value == 3 ? 'cir3' : 'cir4'"></div>
              <span>{{ item.num }}</span>
            </div>
            <div class="cirb">{{ item.name }}</div>
            <span class="subtit">{{item.subtitle}}</span>
          </div>
          <!-- <div class="b_item">
            <div class="itemBox">
              <div class="cir cir4"></div>
              <span>2000+</span>
            </div>
            <div class="cirb">业务标签</div>
          </div> -->
        </div>
      </div>
    </div>
  </swiper-slide>
</template>
<script>
import headBar from "../components/headBar.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";
export default {
  name: "tagData",
  components: {
    swiper,
    swiperSlide,
    headBar
  },
  data() {
    return {
      main_title: require("../assets/title2.png"),
      timer: null,
      activeNum: 0,
      flyData: [
        "运动",
        "电商",
        "教育",
        "汽车",
        "健康",
        "医疗",
        "出行",
        "餐饮",
        "体育",
        "家具",
        "广告",
        "媒体",
        "文体娱乐",
        "机械制造",
        "计算机",
        "互联网",
        "通信电子",
        "建筑",
        "金融",
        "银行",
        "保险",
        "房地产",
        "旅游",
        "贸易",
        "零售",
        "保健",
        "住宿",
        "服务业",
        "备婚",
        "征婚",
        "搬家",
        "购房",
        "装修",
        "留学",
        "高考",
        "考研",
        "找工作",
        "想购车",
        "初中",
        "箱包",
        "军事",
        "小学",
        "彩票",
        "美妆",
        "八卦",
        "电器",
        "保险",
        "交通",
        "手机",
        "数码配件",
        "数码影音",
        "相机摄影",
        "奢侈品",
        "手表",
        "箱包",
        "烟具酒具",
        "眼镜",
        "珠宝首饰",
        "厨具餐具",
        "家纺",
        "家装软饰",
        "住宅家居",
        "厨房电器",
        "健康电器",
        "小家电",
        "大家电",
        "奶粉",
        "童车童床",
        "营养辅食",
        "烹饪",
        "保健食品",
        "茶",
        "酒",
        "零食坚果",
        "饮料乳品",
        "车身结构",
        "MPV",
        "SUV",
        "紧凑型车",
        "跑车",
        "微型车",
        "小型车",
        "中大型车",
        "中型车",
        "车展",
        "汽车配置",
        "奥迪",
        "宝马",
        "本田",
        "标致",
        "别克",
        "大众",
        "丰田",
        "福特",
        "雷诺",
        "马自达",
        "奇瑞",
        "起亚",
        "日产",
        "斯柯达",
        "现代",
        "雪佛兰",
        "雪铁龙",
        "汽车电器",
        "汽车装饰",
        "小游戏",
        "回合游戏",
        "即时战斗",
        "模拟经营",
        "棋牌类",
        "手机游戏",
        "体育游戏",
        "网页游戏",
        "网友端游",
        "休闲竞技",
        "战争策略",
        "医疗健康",
        "格斗",
        "P2P",
        "储蓄",
        "债券",
        "时政",
        "游戏竞技",
        "生活服务",
        "院线电影",
        "动画漫画",
        "娱乐综艺",
        "动漫周边",
        "经济管理",
        "青春动漫",
        "心理学",
        "社会学科",
        "期刊杂志",
        "国学",
        "哲学",
        "遥控电动", //
        "婴幼玩具",
        "积木拼插",
        "模型组装",
        "科教",
        "传记",
        "考试",
        "教材教辅",
        "时尚",
        "少儿",
        "孕产育儿",
        "家居休闲",
        "地图",
        "英语",
        "外语", //
        "恋爱",
        "宗教",
        "政治",
        "辞典",
        "工具书",
        "进口原版",
        "轮船",
        "婚恋交友",
        "社交网络",
        "综合论坛",
        "IT培训",
        "基金"
      ],
      dataListL: [
        {
          name: "基础属性标签",
          subtitle:"性别，年龄，地区，app行为等",
          num: "20000+",
          value: 1,
        },
        {
          name: "大类标签",
          num: "18+",
          value: 2
        }
      ],
      dataListR: [
        {
          name: "算法逻辑标签",
          subtitle:"时尚达人，高级用户等",
          num: "1000+",
          value: 3,
        },
        {
          name: "场景类型标签",
          subtitle:"母婴类人群等",
          num: "2000+",
          value: 4,
        },
      ]
    };
  },
  mounted() {
    this.human();
  },
  created() {
    this.timeR();
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    timeR() {
      this.timer = setInterval(() => {
        this.activeNum++;
        if (this.activeNum > 6) {
          this.activeNum = 1;
        }
      }, 2000);
    },
    human() {
      var flyData = this.flyData;
      var length = 144; //li总个数
      var oUl = document.getElementById("list").children[0]; //所有li的父级
      var aLi = oUl.children; //所有li

      //初始化
      (function() {
        for (var i = 0; i < length; i++) {
          var oLi = document.createElement("li");
          oLi.index = i;
          oLi.x = i % 5;
          oLi.y = Math.floor((i % 25) / 5);
          oLi.z = 4 - Math.floor(i / 25);
          var d = flyData;
          oLi.innerHTML =
            "<b class='liCover'></b>" + "<p class='liTitle'>" + d[i] + "</p>";

          var tX = Math.random() * 6000 - 3000,
            tY = Math.random() * 6000 - 3000,
            tZ = Math.random() * 6000 - 3000;

          oLi.style.transform =
            "translate3D(" + tX + "px," + tY + "px," + tZ + "px)";
          oUl.appendChild(oLi);
        }
        setTimeout(Grid, 200);
      })();

      //拖拽/滚轮事件的添加
      (function() {
        var roX = 0,
          roY = 0,
          trZ = -2000,
          timerMouse = null;

        document.onselectstart = function() {
          return false;
        };
        document.ondrag = function() {
          return false;
        };
        document.onmousedown = function(e) {
          //取消掉还没完成的惯性
          cancelAnimationFrame(timerMouse);

          var sX = e.clientX,
            sY = e.clientY,
            lastX = sX, //存最后一次move的坐标
            lastY = sY, //存最后一次move的坐标
            x_ = 0, //用来存最后两次move的距离差
            y_ = 0, //用来存最后两次move的距离差
            ifMove = false, //检测up之前是否有move
            moveTime = 0, //用来解决最后一次move后很久再up还会有惯性的问题
            ifTime = new Date(); //解决短时间内误拖拽导致弹出层不出来的问题

          //解决down和up在同一个li身上触发，导致拖拽结束后还会弹窗的问题
          if (/b/i.test(e.target.nodeName)) {
            var thisLi = e.target;
          }

          this.onmousemove = function(e) {
            ifMove = true;
            x_ = e.clientX - lastX;
            y_ = e.clientY - lastY;

            roX -= y_ * 0.15;
            roY += x_ * 0.15;

            oUl.style.transform =
              "translateZ(" +
              trZ +
              "px) rotateX(" +
              roX +
              "deg) rotateY(" +
              roY +
              "deg)";

            lastX = e.clientX;
            lastY = e.clientY;

            moveTime = new Date();
          };
          this.onmouseup = function(e) {
            if (ifMove && e.target === thisLi && new Date() - ifTime > 500) {
              thisLi.goudan = true; //给true的话，就会阻止弹窗的发生
            }
            this.onmousemove = null;

            function m() {
              x_ *= 0.9;
              y_ *= 0.9;
              roX -= y_ * 0.15;
              roY += x_ * 0.15;
              oUl.style.transform =
                "translateZ(" +
                trZ +
                "px) rotateX(" +
                roX +
                "deg) rotateY(" +
                roY +
                "deg)";
              if (Math.abs(x_) < 0.1 && Math.abs(y_) < 0.1) return;
              timerMouse = requestAnimationFrame(m);
            }
            if (new Date() - moveTime < 100) {
              timerMouse = requestAnimationFrame(m);
            }
          };
        };

        !(function(fn) {
          if (document.onmousewheel === undefined) {
            document.addEventListener(
              "DOMMouseScroll",
              function(e) {
                var d = -e.detail / 3;
                fn.call(this, d);
              },
              false
            );
          } else {
            document.onmousewheel = function(e) {
              var d = e.wheelDelta / 120;
              fn.call(this, d);
            };
          }
        })(function(d) {
          trZ += d * 100;
          oUl.style.transform =
            "translateZ(" +
            trZ +
            "px) rotateX(" +
            roX +
            "deg) rotateY(" +
            roY +
            "deg)";
        });
      })();

      //左下btn点击
      (function() {
        var aBtn = document.getElementById("btn").getElementsByTagName("li");
        var arr = [Table, Sphere, Helix, Grid];
        for (var i = 0, length = aBtn.length; i < length; i++) {
          (function(i) {
            aBtn[i].onclick = arr[i];
          })(i);
        }
      })();
      var timer = null;

      function paly() {
        var aaa = [Table, Sphere, Helix, Grid];
        var i = 0;
        timer = setInterval(() => {
          aaa[i]();
          if (i >= 3) {
            i = 0;
          } else {
            i++;
          }
        }, 4000);
      }
      paly();
      (function() {
        var all = document.getElementById("all");
        all.onmouseenter = function() {
          clearInterval(timer);
        };
        all.onmouseleave = function() {
          paly();
        };
      })();
      //Table 元素周期表布局
      function Table() {
        if (Table.arr) {
          for (var i = 0; i < length; i++) {
            aLi[i].style.transform = Table.arr[i];
          }
        } else {
          Table.arr = [];
          var n = Math.ceil(length / 18) + 2;
          var midY = n / 2 - 0.5;
          var midX = 18 / 2 - 0.5;
          var disX = 170;
          var disY = 210;

          var arr = [
            {
              x: 0,
              y: 0
            },
            {
              x: 17,
              y: 0
            },
            {
              x: 0,
              y: 1
            },
            {
              x: 1,
              y: 1
            },
            {
              x: 12,
              y: 1
            },
            {
              x: 13,
              y: 1
            },
            {
              x: 14,
              y: 1
            },
            {
              x: 15,
              y: 1
            },
            {
              x: 16,
              y: 1
            },
            {
              x: 17,
              y: 1
            },
            {
              x: 0,
              y: 2
            },
            {
              x: 1,
              y: 2
            },
            {
              x: 12,
              y: 2
            },
            {
              x: 13,
              y: 2
            },
            {
              x: 14,
              y: 2
            },
            {
              x: 15,
              y: 2
            },
            {
              x: 16,
              y: 2
            },
            {
              x: 17,
              y: 2
            }
          ];

          for (i = 0; i < length; i++) {
            var x, y;
            if (i < 18) {
              x = arr[i].x;
              y = arr[i].y;
            } else {
              x = i % 18;
              y = Math.floor(i / 18) + 2;
            }
            var val =
              "translate3D(" +
              (x - midX) * disX +
              "px," +
              (y - midY) * disY +
              "px,0px)";
            Table.arr[i] = val;
            aLi[i].style.transform = val;
          }
        }
      }

      //Sphere 球状布局
      function Sphere() {
        if (Sphere.arr) {
          for (var i = 0; i < length; i++) {
            aLi[i].style.transform = Sphere.arr[i];
          }
        } else {
          Sphere.arr = [];
          var arr = [1, 3, 7, 9, 11, 14, 21, 16, 12, 10, 9, 7, 4, 1],
            arrLength = arr.length,
            xDeg = 180 / (arrLength - 1);
          for (i = 0; i < length; i++) {
            //求出当前 i 处于arr的第几层 第几个
            var numC = 0,
              numG = 0;
            var arrSum = 0;
            for (var j = 0; j < arrLength; j++) {
              arrSum += arr[j];
              if (arrSum > i) {
                numC = j;
                numG = arr[j] - (arrSum - i);
                break;
              }
            }
            var yDeg = 360 / arr[numC];
            var val =
              "rotateY(" +
              (numG + 1.3) * yDeg +
              "deg) rotateX(" +
              (90 - numC * xDeg) +
              "deg) translateZ(800px)";
            Sphere.arr[i] = val;
            aLi[i].style.transform = val;
          }
        }
      }

      //Helix 螺旋式布局
      function Helix() {
        if (Helix.arr) {
          for (var i = 0; i < length; i++) {
            aLi[i].style.transform = Helix.arr[i];
          }
        } else {
          Helix.arr = [];
          var h = 3.7, //环数
            tY = 7, //每个li上下位移相差
            num = Math.round(length / h), //每环个数
            deg = 360 / num, //每个li Y旋转相差
            mid = length / 2 - 0.5; //找准中间点
          for (i = 0; i < length; i++) {
            var val =
              "rotateY(" +
              i * deg +
              "deg) translateY(" +
              (i - mid) * tY +
              "px) translateZ(800px)";
            Helix.arr[i] = val;
            aLi[i].style.transform = val;
          }
        }
      }

      //Grid 层叠式布局
      function Grid() {
        if (Grid.arr) {
          for (i = 0; i < length; i++) {
            aLi[i].style.transform = Grid.arr[i];
          }
        } else {
          Grid.arr = [];
          var disX = 350; //每个li 水平（x）方向的间距
          var disY = 350; //每个li 垂直（y）方向的间距
          var disZ = 800; //每个li 纵深（z）方向的间距
          for (var i = 0; i < length; i++) {
            var oLi = aLi[i];
            var x = (oLi.x - 2) * disX,
              y = (oLi.y - 2) * disY,
              z = (oLi.z - 2) * disZ;
            var val = "translate3D(" + x + "px," + y + "px," + z + "px)";
            Grid.arr[i] = val;
            oLi.style.transform = val;
          }
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import "../style/tag.less";
@import "../style/human.css";
</style>